import { Component } from "@angular/core";
import { BaseFieldComponent } from "../base-field/base-field.component";
import { FieldTypes } from "@nts/std/types";

@Component({
    template: '',
    selector: 'nts-simple-field'
})
export abstract class SimpleFieldComponent extends BaseFieldComponent {
    override type = FieldTypes.Simple;
    abstract get multiline(): boolean;
}
